import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Link from 'next/link';

import { withTranslation } from 'language/i18n';
import Breadcrumb from 'components/Breadcrumb';
import Layout from 'components/partials/Layout';
import machineBrands from 'constants/machineBrands.json';
import machineCategories from 'constants/machineCategories.json';
import { MACHINE_STATE } from 'constants/common';
import DetailSection from '../components/detail/DetailSection';
import BrandsSection from '../components/detail/BrandsSection';
import CategoriesSection from '../components/detail/CategoriesSection';

const BrandDetail = ({ t, content }) => {
  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('brands'),
      url: '/brands',
    },
    {
      label: content.title,
      url: `/brands/detail/${content.id}`,
    },
  ];

  return (
    <main className="has-header">
      <div className="brand-detail container">
        <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3">
          <div className="col">
            <Breadcrumb links={breadcrumbs} />
          </div>
        </div>
        <DetailSection
          content={content}
          type="brands"
        />
        <div className="col text-center mt-2 mb-5">
          <Link href={`/machinery?state=${MACHINE_STATE.IN_EVENT}`}>
            <a className="im-button im-button--primary" href="/faq/buyers">{t('viewMachinesForSale')}</a>
          </Link>
        </div>
        <div className="section-line" />
        <BrandsSection brands={machineBrands} />
        <div className="section-line" />
        <CategoriesSection categories={machineCategories} />
        {/*  <div className="section-line" />
        <OnSaleSection machines={machinesOnSale} />
        <div className="section-line" />
        <SoldsSection machines={soldMachines} /> */}
      </div>
    </main>
  );
};

BrandDetail.propTypes = {
  t: PropTypes.func,
  content: PropTypes.object,
};

export const getStaticProps = async ({ params }) => {
  const { id } = params;
  const content = _.find(machineBrands, ['id', id]);

  return {
    props: {
      blackHeader: true,
      headTitle: content.title,
      content,
    },
  };
};

export const getStaticPaths = async () => {
  const paths = _.map(machineBrands, (brand) => {
    return {
      params: {
        id: brand.id,
      },
    };
  });

  return {
    fallback: false,
    paths,
  };
};

BrandDetail.Layout = Layout;

export default withTranslation('common')(BrandDetail);
